import { isDefined } from "types/predicates";

export default (user: { name?: string | null; email?: string | null } = {}) =>
  [user.name, user.email].filter(isDefined).join(" • ");
